import React from 'react';

import { VideoIcon, LayersIcon, ChevronDoubleRightIcon } from '@vlabs/icons';
import {
  Layout,
} from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { generatePath, Switch, Route, Redirect } from 'react-router-dom';

import GroupListPage from 'partials/features/groups/GroupListPage';
import GroupPage from 'partials/features/groups/GroupPage';
import { LogsPage } from 'partials/features/logs/LogsPage';
import QueuePage from 'partials/features/queue/QueuePage';
import { EditStreamPage } from 'partials/features/streams/EditStreamPage';
import StreamListPage from 'partials/features/streams/StreamListPage';
import { StreamPage } from 'partials/features/streams/StreamPage';

import { routes } from './routes';
import './App.sass';

function App() {
  const { t } = useTranslation();
  return (
    <Layout.Base>
      <div className="App__Sticky">
        <Layout.Navbar>
          <Layout.NavbarLink icon={<VideoIcon />} to={generatePath(routes.sources.main)}>
            {t('lunaStreamsStreams:название раздела')}
          </Layout.NavbarLink>
          <Layout.NavbarLink icon={<LayersIcon />} to={generatePath(routes.sources.lunaStreams.groups.main)}>
            {t('lunaStreamsGroups:название раздела')}
          </Layout.NavbarLink>
          <Layout.NavbarLink icon={<ChevronDoubleRightIcon />} to={generatePath(routes.sources.lunaStreams.queue.main)}>
            {t('lunaStreamsQueue:название раздела')}
          </Layout.NavbarLink>
          <Layout.NavbarLink to={generatePath(routes.sources.lunaStreams.logs.main)}>
            {t('lunaStreamsLogs:название раздела')}
          </Layout.NavbarLink>
        </Layout.Navbar>
      </div>
      <Layout.Content>
        <Switch>
          <Route component={QueuePage} path={routes.sources.lunaStreams.queue.main} />
          <Route
            path={routes.sources.lunaStreams.streams.create}
            render={(router) => (
              <EditStreamPage
                {...router}
                afterCreateStream={(streamId) => {
                  router.history.replace(
                    generatePath(routes.sources.lunaStreams.streams.view, { streamId }),
                  );
                }}
                afterDeleteStream={() => {
                  router.history.push(
                    generatePath(routes.sources.main),
                  );
                }}
                streamId="create"
              />
            )}
          />
          <Route
            path={routes.sources.lunaStreams.streams.edit}
            render={(router) => (
              <EditStreamPage
                {...router}
                afterCreateStream={(streamId) => {
                  router.history.replace(
                    generatePath(routes.sources.lunaStreams.streams.view, { streamId }),
                  );
                }}
                afterDeleteStream={() => {
                  router.history.push(
                    generatePath(routes.sources.main),
                  );
                }}
                streamId={router.match.params.streamId}
              />
            )}
          />
          <Route
            path={routes.sources.lunaStreams.streams.view}
            render={(router) => (
              <StreamPage
                {...router}
                can={() => true}
                streamId={router.match.params.streamId}
              />
            )}
          />
          <Route
            path={routes.sources.main}
            render={(router) => (
              <StreamListPage
                {...router}
                onAddStreamClick={() => {
                  router.history.push(
                    generatePath(routes.sources.lunaStreams.streams.create),
                  );
                }}
                onEditStreamClick={(streamId) => {
                  router.history.push(
                    generatePath(routes.sources.lunaStreams.streams.edit, { streamId }),
                  );
                }}
              />
            )}
          />
          <Route
            path={routes.sources.lunaStreams.groups.view}
            render={(router) => (
              <GroupPage
                {...router}
                afterCreateGroup={(groupId) => {
                  router.history.replace(
                    generatePath(routes.sources.lunaStreams.groups.view, { groupId }),
                  );
                }}
                afterDeleteGroup={() => {
                  router.history.push(
                    generatePath(routes.sources.lunaStreams.groups.main),
                  );
                }}
                groupId={router.match.params.groupId}
              />
            )}
          />
          <Route
            path={routes.sources.lunaStreams.groups.main}
            render={(router) => (
              <GroupListPage
                {...router}
                onAddGroupClick={() => router.history.push(
                  generatePath(routes.sources.lunaStreams.groups.create),
                )}
                onEditGroupClick={(groupId) => router.history.push(
                  generatePath(routes.sources.lunaStreams.groups.view, { groupId }),
                )}
              />
            )}
          />
          <Route
            path={routes.sources.lunaStreams.logs.main}
            render={() => <LogsPage />}
          />
          <Route path="*" render={() => <Redirect to={generatePath(routes.sources.main)} />} />
        </Switch>
      </Layout.Content>
    </Layout.Base>
  );
}

export default App;
